import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function getCustomer(params) {
    const { baseUrl, brandId, country, uberToken } = params;

    invariant(baseUrl, 'baseUrl is a required param of getCustomer()');
    invariant(brandId, 'brandId is a required param of getCustomer()');
    invariant(country, 'country is a required param of getCustomer()');
    invariant(uberToken, 'uberToken is a required param of getCustomer()');

    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/customer`;

    return labelRequest(authenticatedRequest(new Request(url), uberToken), 'getCustomer');
}
